// El Estudio de video abierto desde Redes queda "a mano" —
// ADR-2026-10-05-el-estudio-desde-redes-queda-a-mano.
//
// Cuando desde una sesión de Redes (`/redes/:sesionId`) se edita un video en el Estudio, se
// recuerda el proyecto de ESA sesión: la sesión muestra entonces "Estudio de video" al lado
// de Cuadrícula | Canva y lleva al último proyecto abierto desde ahí. Y el editor, sólo si se
// llegó desde Redes, ofrece "Volver a creaciones" (la vuelta viaja en el estado de la
// navegación, no en el proyecto: abrir el mismo proyecto desde la lista de proyectos no lo
// muestra).
//
// Vive en `localStorage` (por navegador): es una comodidad, no un dato que tenga que
// sobrevivir a otro dispositivo. Todo acceso va en try/catch.

const CLAVE = 'atlas:estudio-desde-redes';
/** Cuántas sesiones se recuerdan; las más viejas se van. */
const TOPE = 30;

type Registro = { sesionId: string; projectId: string }[];

function leer(): Registro {
  try {
    const crudo = localStorage.getItem(CLAVE);
    const v = crudo ? (JSON.parse(crudo) as unknown) : [];
    return Array.isArray(v)
      ? v.filter((x): x is Registro[number] => !!x && typeof x.sesionId === 'string' && typeof x.projectId === 'string')
      : [];
  } catch {
    return [];
  }
}

/** La sesión de Redes de una ruta (`/redes/:sesionId`), o `null`. */
export function sesionDeRedes(pathname: string): string | null {
  const m = /^\/redes\/([^/?#]+)/.exec(pathname);
  return m ? decodeURIComponent(m[1]) : null;
}

/** Recuerda el último proyecto del Estudio abierto desde esta sesión de Redes. */
export function recordarProyectoDeRedes(sesionId: string, projectId: string): void {
  const resto = leer().filter((r) => r.sesionId !== sesionId);
  try {
    localStorage.setItem(CLAVE, JSON.stringify([{ sesionId, projectId }, ...resto].slice(0, TOPE)));
  } catch {
    /* sin storage: la sesión simplemente no muestra el atajo */
  }
}

/** El último proyecto del Estudio abierto desde esta sesión, o `null`. */
export function proyectoDeRedes(sesionId: string | undefined | null): string | null {
  if (!sesionId) return null;
  return leer().find((r) => r.sesionId === sesionId)?.projectId ?? null;
}

/** El estado de navegación con el que el editor sabe a dónde volver. */
export const estadoDesdeRedes = (ruta: string) => ({ volverACreaciones: ruta });

/** La ruta de vuelta a Redes que trae la navegación, o `null` si no se llegó desde ahí. */
export function rutaDeVueltaARedes(state: unknown): string | null {
  const r = (state as { volverACreaciones?: unknown } | null)?.volverACreaciones;
  return typeof r === 'string' && r.startsWith('/redes') ? r : null;
}
